export var menuItems={
  "data": [
    {
      "path": "/",
      "title": "Dashboard",
      "icon": "stroke-home",
      "iconf":"fill-home",
      "type": "link"
    },
    {
      "path": "/emitidos",
      "title": "Emitidos",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "link",
      "active": false
    },
    {
      "path": "/recibidos",
      "title": "Recibidos",
      "icon": "stroke-table",
      "iconf":"fill-table",
      "type": "link",
      "active": false
    },
    {
      "title": "Conciliaciones PPD",
      "icon": "stroke-charts",
      "iconf":"fill-charts",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/conciliacion-pagos/emitidos",
          "title": "Emitidos",
          "type": "link",
          "active": false
        },
        {
          "path": "/conciliacion-pagos/recibidos",
          "title": "Recibidos",
          "type": "link",
          "active": false
        }
      ]
    },
    {
      "path": "/validaciones",
      "title": "Validaciones",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "link",
      "active": false
    },
    {
      "title": "Reportes",
      "icon": "stroke-charts",
      "iconf":"fill-charts",
      "type": "sub",
      "active": false,
      "children": [
        {
          "path": "/cfdis-por-pagar",
          "title": "CFDIs por Pagar",
          "type": "link",
          "active": false
        },
        {
          "path": "/cfdis-por-cobrar",
          "title": "CFDIs por Cobrar",
          "type": "link",
          "active": false
        },
        {
          "path": "/papel-trabajo-diot",
          "title": "DIOT",
          "type": "link",
          "active": false
        },
        {
          "path": "/impuestos",
          "title": "Impuestos",
          "type": "link",
          "active": false
        }
      ]
    },
    {
      "path": "/centro-descargas",
      "title": "Centro de Descargas",
      "icon": "stroke-file",
      "iconf":"fill-file",
      "type": "link",
      "active": false
    }
  ]
}